import React from "react";
import {
  ContentBlock,
  FormGroup,
  Button,
  StatusDot,
  Pill,
  FormFooter
} from "xsolla-uikit";
import PAh2 from "../PAh2";
import styled, { css } from "styled-components";

import {
  xsollaProducts} from "../../data/xsollaProducts";
import { xsollaProductsStatus } from "../../data/xsollaProductsStatus";

import PAtopMenu, { countMenu } from "../menu/PAtopMenu";
import { PAcard } from "../cards/PAcard";
import CardNew from "../PAcardNew";

export default function PAapps() {
  return (
    <div style={{padding: '16px 24px 44px 24px'}}>
      {/* <ContentBlock> */}
      <FormGroup indentation="lg">
        <ContentBlock appearance="flatten">
          <PAh2 title="Selling" />
          <br />
          <FormGroup indentation="lg">
            <CSSline>
              <PAoneApp product="currency" />
              <PAoneApp product="subscriptions" />
              <PAoneApp product="game_store" />
            </CSSline>
          </FormGroup>
        </ContentBlock>
      </FormGroup>

      <br />
      <br />

      <FormGroup indentation="lg">
        <ContentBlock appearance="flatten">
          <PAh2 title="Means of distribution" />
          <br />
          <FormGroup indentation="lg">
            <CSSline>
              <PAoneApp product="game_store" />
              <PAoneApp product="site_builder" />
              {/* <PAoneApp product="site_builder"/> */}
            </CSSline>
          </FormGroup>
        </ContentBlock>
      </FormGroup>
      {/* </ContentBlock> */}

      <br />
      <br />

      <FormGroup indentation="lg">
        <ContentBlock appearance="flatten">
          <PAh2 title="Essentials" />
      <br />
          <FormGroup indentation="lg">
            <CSSline>
              <PAoneApp product="pay_station" />
              <PAoneApp product="login" />
              <PAoneApp product="partner_network" />
            </CSSline>
          </FormGroup>
        </ContentBlock>
      </FormGroup>
    </div>
  );
}

export const PAoneApp = ({ product }) => {
  return (
    <CSSoneApp00>
      {/* <ContentBlock size="sm"> */}
      {/* <CardNew> */}

      <CSSoneApp0>
        <CSSoneApp product={product} />
        <CSSright>
          <FormGroup indentation="xs">
            <StatusDot status={xsollaProductsStatus[product]["status"]}>
              {xsollaProductsStatus[product]["statusName"]}
            </StatusDot>
          </FormGroup>

          <PAh2
            tag="h4"
            title={
              xsollaProducts[product]["name"]
                // ? xsollaProducts[product]["name"]
                // : xsollaProducts[product]["name"]
            }
            // indentation='lg'
          >
            {/* {xsollaProductsStatus[product] &&
<div style={{marginTop: -16}}>
          <StatusDot status={xsollaProductsStatus[product]['status']}>
            {xsollaProductsStatus[product]['statusName']}
          </StatusDot></div>} */}
          </PAh2>

          {/* <StatusDot status="testing"/> */}
          <p>
          <CSSinfo>
            {xsollaProductsStatus[product] &&
              xsollaProductsStatus[product]["info"]}
          </CSSinfo>
          </p>

<br/>
          <div
            style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end'}}
            >
            Provided by:<br/>
            <PAtopMenu
              renderProducts={[
                xsollaProducts[product]["sub"]
                  ? xsollaProducts[product]["sub"]
                  : xsollaProducts[product]["id"]
              ]}
              size="sm"
              // renderProducts={["store"]}
              // pathname={props.location.pathname}
            />
          </div>
        </CSSright>
      </CSSoneApp0>

      {/* </CardNew> */}

      {/* </ContentBlock> */}
    </CSSoneApp00>
  );
};

export const CSSline = styled.div`
  /* display: grid; */
  display: flex;
  /* grid-template-columns: 1fr 1fr 1fr; */
  /* grid-column-gap: 24px; */
`;

export const CSSoneApp00 = styled.div`
  /* display: flex; */
  flex-grow: 1;
  align-items: stretch;
  justify-content: stretch;
  /* margin-right: 24px; */
`;

export const CSSapps0 = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
`;

export const CSSright = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: stretch;
`;

export const CSSoneApp0 = styled.div`
  /* display: flex; */
  display: grid;
  grid-template-columns: 130px 1fr;
  grid-column-gap: 16px;
  /* flex-grow: 1; */
  /* margin-left: -16px; */
  /* border: 1px solid #6AABE8; */
  /* background-color: #f7faff; */
  /* border-radius: 6px; */
  display: flex;
  align-items: stretch;
  /* padding: 16px 20px; */
  /* margin-right: 24px; */
`;

export const CSSinfo = styled.div`
  color: #747e8a;
  font-size: 13px;
  flex-grow: 1;
`;

export const CSSoneApp = styled.div`
  border: 1px solid #6aabe8;
  height: 180px;
  border-radius: 6px;
  background-color: #e9f5fe;
  width: 140px;
  margin-right: 16px;
  min-height: 160px;
  background-position: 50% 50%;
  background-size: 100%;
  background-repeat: no-repeat;
  ${({ product }) =>
    !!product &&
    css`
      background-image: url(${xsollaProducts[product]["pic"]});
    `}
`;
